import React from 'react';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './PatientCareCenterButton.module.css';
import { CommonButton } from '_components';


export class ViewButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'View'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faEye} transform="shrink-6 left-1" color="white" />
            </CommonButton>
        );
    }
}
